<div class="orders-list-tree" id="orders-list-tree">
  <dx-tree-list
    #tree
    class="tree-table"
    [dataSource]="dataSource"
    keyExpr="id"
    parentIdExpr="parentId"
    hasItemsExpr="hasItems"
    [autoExpandAll]="false"
    [noDataText]="treeOptions?.noDataText"
    [remoteOperations]="treeOptions.remoteOperations"
    [allowColumnResizing]="treeOptions?.columnResizing"
    [columnAutoWidth]="treeOptions?.columnAutoWidth"
    [paging]="{ enabled: false }"
    [columnFixing]="{ enabled: true }"
    [selection]="{ recursive: true }"
    [loadPanel]="{ enabled: false }"
    [scrolling]="{ mode: 'standard' }"
    columnResizingMode="nextColumn"
    [wordWrapEnabled]="true"
    [showBorders]="true"
    [showColumnLines]="false"
    [showRowLines]="false"
    [rowAlternationEnabled]="true"
    [hoverStateEnabled]="true"
    [rootValue]="null"
    (onCellPrepared)="onCellPrepared($event)"
    (onSelectionChanged)="onSelectionChanged($event)"
    (onRowDblClick)="onRowDblClick($event)"
    (onContentReady)="onContentReadyCallback($event)"
  >
    <dxo-sorting mode="single"></dxo-sorting>
    <dxo-selection
      #dxoSelection
      [mode]="treeOptions.selectionMode"
      [allowSelectAll]="true"
      showCheckBoxesMode="always"
      [selectAllMode]="'allPages'"
    ></dxo-selection>

    @for(column of columns ;track $index ; let i =$index) {
    <dxi-column
      [visible]="column?.visible ?? true"
      [ngClass]="column?.cssClass"
      [name]="column?.id"
      [dataField]="column?.id"
      [caption]="column?.caption | translate"
      [alignment]="column?.alignment"
      [sortIndex]="column?.sortIndex"
      [sortOrder]="column?.sortOrder"
      [allowSorting]="column?.allowSorting !== false"
      [width]="column?.width"
      [cellTemplate]="column?.cellTemplate"
      [calculateCellValue]="column?.calculateCellValue"
      headerCellTemplate="headerTemplate"
    >
    </dxi-column
    >}
    <div *dxTemplate="let data of 'headerTemplate'">
      <div class="tree-list-default-hdr" [ngClass]="{ 'no-sort': !data?.column?.allowSorting }">
        <div class="tree-list-col-name" title="{{ data?.column?.caption }}">{{ data?.column?.caption }}</div>
        @if(data?.column?.allowSorting) {
        <div class="tree-list-col-sort-btns">
          <button
            mat-icon-button
            class="tree-list-header-arrow"
            (click)="sortColumn($event, data?.column, 'asc', true)"
          >
            <mat-icon [ngClass]="{ selected: isColumnSorted(data?.column, 'asc') }">expand_less</mat-icon>
          </button>
          <button
            mat-icon-button
            class="tree-list-header-arrow"
            (click)="sortColumn($event, data?.column, 'desc', true)"
          >
            <mat-icon [ngClass]="{ selected: isColumnSorted(data?.column, 'desc') }">expand_more</mat-icon>
          </button>
        </div>
        }
      </div>
    </div>
    <div *dxTemplate="let d of 'orderNumberColumn'">
      <div class="orders-list-order-nbr">
        <button
          mat-icon-button
          class="done-all-btn"
          (click)="toggleOrderFolders(d?.data?.orderId)"
        >
          <mat-icon
            [ngClass]="{ selected: isOrderSelected(d?.data?.orderId) }"
            [ngbTooltip]="
              (isOrderSelected(d?.data?.orderId) ? 'orders.info.unselectAll' : 'orders.info.selectAll')
                | translate
            "
            container="body"
            [openDelay]="500"
            [placement]="'auto'"
            [closeDelay]="0"
            >done_all</mat-icon
          >
        </button>

        <div class="orders-list-order-nbr-label">
          {{ d?.data?.orderId }}
        </div>
      </div>
    </div>
    <div *dxTemplate="let d of 'bookingDateColumn'">
      @if(!d?.data?.parentId) {
      <div class="tree-list-default-cell">
        <span
          [ngbTooltip]="d.data?.bookingDate | dateFormat : 'dd/MM/yyyy - HH:mm'"
          [openDelay]="500"
          [placement]="'auto'"
          container="body"
          [closeDelay]="0"
        >
          {{ d.data?.bookingDate | dateFormat : 'dd/MM/yyyy - HH:mm' }}
        </span>
      </div>
      }
    </div>
    <div *dxTemplate="let d of 'customerIdColumn'">
      @if(!d?.data?.parentId) {
      <div class="tree-list-default-cell">
        <span
          [ngbTooltip]="d.data?.customer?.id"
          [openDelay]="500"
          [placement]="'auto'"
          container="body"
          [closeDelay]="0"
          >{{ d.data?.customer?.id }}</span
        >
      </div>
      }
    </div>
    <div *dxTemplate="let d of 'customerNameColumn'">
      @if(!d?.data?.parentId) {
      <div class="d-flex align-items-center">
        @if(d?.value) {
        <mat-icon class="material-icons-outlined me-1">{{
          d.data?.customer?.customerType === customerTypeEnumResponseDto.Physical ? 'face' : 'business'
        }}</mat-icon>
        }
        <span
          class="text-overflow"
          [ngbTooltip]="d?.value"
          [openDelay]="500"
          [placement]="'auto'"
          container="body"
          [closeDelay]="0"
        >
          {{ d?.value || ('shared.customer.anonymousCustomer' | translate) }}
        </span>
      </div>
      }
    </div>

    <div *dxTemplate="let d of 'orderLabelColumn'">
      <div class="tree-list-multifield-cell">
        @if(d?.data?.hasItems){
        <div class="orders-list-toggle">
          <button mat-icon-button class="tree-toggle-btn d-flex me-2" (click)="toggleRow(d.key)">
            <mat-icon>{{ isExpanded(d.key) ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
        </div>
        } @if(d?.data?.orderItemRowType === orderItemRowType.Product){
        <mat-icon class="material-icons-outlined me-1">shopping_cart</mat-icon>
        }
        <ng-template #orderLabelTooltip>
          {{ d?.value }}
          @if(d?.data?.eventDate) {
          {{ d?.data?.eventDate | dateFormat : 'dd/MM/yyyy - HH:mm' }}
          } @if(d?.data?.hasItems) {
          <div>{{ 'orders.eventCount' | translate : { count: d?.data?.orderItemCount } }}</div>
          }
        </ng-template>
        <span
          class="tree-list-text"
          [ngbTooltip]="orderLabelTooltip"
          [openDelay]="500"
          [placement]="'auto'"
          container="body"
          [closeDelay]="0"
        >
          {{ d?.value }}
          @if(d.data?.eventDate) { {{ d.data?.eventDate | dateFormat : 'dd/MM/yyyy - HH:mm' }}}
          @if(d?.data?.hasItems){
          <span class="event-count">
            {{ 'orders.eventCount' | translate : { count: d?.data?.orderItemCount } }}
          </span>
          }
        </span>
      </div>
    </div>
    <div *dxTemplate="let d of 'categoriesColumn'">
      @if(d.data?.category) {
      <span
        class="orders-list-categories"
        [ngbTooltip]="categoryTooltip()"
        (mouseenter)="loadMultiCategories(d.data)"
        [openDelay]="500"
        [placement]="'auto'"
        container="body"
        [closeDelay]="0"
      >
        {{ d.data.category.hasMultiple ? '...' : d.data.category.value }}
      </span>
      }
    </div>
    <div *dxTemplate="let d of 'quantityColumn'">
      <div class="tree-list-default-cell">
        <span
          [ngbTooltip]="d.data?.quantity !== null && d.data?.quantity !== undefined ? d.data.quantity : ''"
          [openDelay]="500"
          [placement]="'auto'"
          container="body"
          [closeDelay]="0"
        >
          {{ d.data?.quantity !== null && d.data?.quantity !== undefined ? d.data.quantity : '' }}
        </span>
      </div>
    </div>
    <div *dxTemplate="let d of 'priceNamesColumn'">
      @if(d.data?.rate) {
      <span
        class="orders-list-prices"
        [ngbTooltip]="rateTooltip()"
        (mouseenter)="loadMultiRates(d.data)"
        [openDelay]="500"
        [placement]="'auto'"
        container="body"
        [closeDelay]="0"
      >
        {{ d.data.rate.hasMultiple ? '...' : d.data.rate.value }}
      </span>
      }
    </div>
    <div *dxTemplate="let d of 'orderAmountColumn'">
      <div class="tree-list-default-cell">
        <span
          [ngbTooltip]="d.data?.amount | currency : 'EUR' : 'symbol' : '0.2-2' : 'fr'"
          [openDelay]="500"
          [placement]="'auto'"
          container="body"
          [closeDelay]="0"
        >
          {{ d.data?.amount | currency : 'EUR' : 'symbol' : '0.2-2' : 'fr' }}
        </span>
      </div>
    </div>
    <div *dxTemplate="let d of 'orderTotalAmountColumn'">
      <div class="tree-list-default-cell">
        <span
          [ngbTooltip]="d.data?.orderTotalAmount | currency : 'EUR' : 'symbol' : '0.2-2' : 'fr'"
          [openDelay]="500"
          [placement]="'auto'"
          container="body"
          [closeDelay]="0"
        >
          {{ d.data?.orderTotalAmount | currency : 'EUR' : 'symbol' : '0.2-2' : 'fr' }}
        </span>
      </div>
    </div>
    <div *dxTemplate="let d of 'operatorColumn'">
      <div class="tree-list-default-cell">
        <span
          [ngbTooltip]="d.data?.salesUser"
          [openDelay]="500"
          [placement]="'auto'"
          container="body"
          [closeDelay]="0"
        >
          {{ d.data?.salesUser }}
        </span>
      </div>
    </div>
    <div *dxTemplate="let d of 'statusColumn'">
      <app-tick-chip [items]="getStatusChipData(d?.data)"></app-tick-chip>
    </div>

    <dxi-column name="hiddenActionsCol" [width]="0" [cellTemplate]="'actionsContainer'"></dxi-column>
    <div class="tree-list-actions-cell" *dxTemplate="let d of 'actionsContainer'">
      <div
        class="tree-list-actions-container"
        appTreeListActions
        [actions]="actions()"
        [fixedActions]="fixedActions()"
        [data]="d?.data"
        [rowIndex]="d?.rowIndex"
        [row]="d?.component?.getRowElement(d?.rowIndex)?.[0]"
      ></div>
    </div>

    <dxo-paging [enabled]="false" [pageSize]="treeOptions.pagination.pageSize"> </dxo-paging>
    <dxo-pager [visible]="false"></dxo-pager>
  </dx-tree-list>

  @if(this.selectedRows()?.length>0 && !isSelectAllValidationPending()){
  <app-tree-list-action-bar
    [actions]="actions()"
    [fixedActions]="fixedActions()"
    [selection]="selectedRows()"
    [actionsBarOptions]="{ width: '', label: 'shared.folders', slice: 3 }"
  >
    <ng-template #selectionSummary let-selection="selection">
      <div class="orders-list-folder-selection">
        <mat-checkbox [ngModel]="isItemsCheckboxSelected" (ngModelChange)="deselectAllRowsFromActionBar()"
          >{{ selectedFoldersCount() }} {{ 'orders.folderSingularPlural' | translate }}</mat-checkbox
        >
      </div>
      <div class="orders-list-orders-count">
        {{ selectedOrdersCount() }} {{ 'orders.orderSingularPlural' | translate }}
      </div>
      <div class="orders-list-orders-amount">
        {{ selectedSeatsCount() }} {{ 'orders.articleSingularPlural' | translate }}:
        {{ selectedTotalAmount() | currency : 'EUR' : 'symbol' : '0.2-2' : 'fr' }}
      </div>
    </ng-template>
  </app-tree-list-action-bar>
  }
</div>

<app-orders-tree-list-pagination
  [totalPages]="totalPages()"
  [currentDataLength]="currentDataLength()"
  [(currentPage)]="currentPage"
  [(pageSize)]="pageSize"
  (pageChange)="onPageChanged($event)"
  (pageSizeChange)="onPageSizeChanged($event)"
></app-orders-tree-list-pagination>

<app-offcanvas
  [panelClass]="'order-details-offcanvas'"
  [component]="detailsComponent"
  (offcanvasClosed)="closeOrderDetails()"
></app-offcanvas>
